const FormatStringToLocale = str => {
  const isNumber = !isNaN(parseInt(str, 10))
  if (isNumber) {
    const removeCommas = str.replace(/,/g, '') || '0'
    return parseInt(removeCommas, 10).toLocaleString('en-GB')
  }

  return ''
}

export default FormatStringToLocale
